import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-error-bib-dialog',
  templateUrl: './error-bib-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ErrorBibDialog {
  reply1: any = 'yes';
  reply2: any = 'no';

  constructor(
    public dialogRef: MatDialogRef<ErrorBibDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  download() {
    this.dialogRef.close('yes');
  }
}
